/**
 * The logo's mark (decision 63; drawn by marketing in docs/marketing/assets/dejo-dicho-mark.svg):
 * a house outline with a speech bubble. Kept here as shapes so every screen draws the same mark.
 */
export const logoMark = {
  viewBox: '0 0 124 117',
  width: 124,
  height: 117,
  strokeWidth: 7.5,
  /** Drawn as lines, in the house color. */
  house: ['M10 64 L53 27.5 L96 64', 'M23 55.5 V107 H83 V55.5', 'M43 107 V87 Q53 76.5 63 87 V107'],
  /** Filled, in the bubble color. */
  bubble: 'M79 6 H111 Q118 6 118 13 V32 Q118 39 111 39 H93 L81.5 49.5 L84 39 H79 Q72 39 72 32 V13 Q72 6 79 6 Z',
  /** The three dots inside the bubble. */
  dots: [85, 95, 105].map((cx) => ({ cx, cy: 22.5, r: 3.4 })),
  colors: { house: '#2B3530', bubble: '#4D6E5C', dots: '#FFFFFF' },
} as const;
